import { useState } from "react";

const useModal = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const toggleModal = (e) => {
    if (e) {
      e.preventDefault();
    }
    setIsOpen(prevState => !prevState);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    toggleModal,
    openModal,
    closeModal
  };
};

export default useModal;
